import React from 'react';

import MovieItem    from './MovieItem';
import MovieHelpers from '../utils/MovieHelpers';
import IntlMessages from '../IntlMessages';


const Messages = IntlMessages[MovieHelpers.getLang()];


const MovieGroup = (props) => {
    if(props.movies.length > 0) {
        return (
            <div>
                <h2>{props.title}</h2>
                <ul className="movies-page__movies__list">
                    {props.movies.map(movie => <MovieItem key={movie._id} movie={movie} />)}
                </ul>
            </div>
        )
    } else {
        return null;
    }
};

export default (props) => {
    const advanceScreening = props.movies.filter( movie => movie.week === -3);
    const premiere = props.movies.filter( movie => (movie.week >= -1) && (movie.week <= 1));
    const regular = props.movies.filter( movie => (movie.week >= 2) && (movie.week <= 96));
    const festival = props.movies.filter( movie => movie.week === -2);
    const specials = props.movies.filter( movie => movie.week >= 97);

    return (
        <div className="movies-page__movies">
            <MovieGroup title={Messages.advanceScreening} movies={advanceScreening}/>
            <MovieGroup title={Messages.newThisWeek} movies={premiere}/>
            <MovieGroup title={Messages.nowBooking} movies={regular}/>
            <MovieGroup title={Messages.festival} movies={festival}/>
            <MovieGroup title={Messages.specials} movies={specials}/>
        </div>
    )
}



// WEBPACK FOOTER //
// ./js/movies/components/MovieList.jsx